import { ComponentLoader } from '@bythepixel/component-loader';
import Lightbox from './lightbox';
import OpenLightbox from './lightbox/openLightbox';

window.trailerComponents = new ComponentLoader(document, [
  Lightbox,
  OpenLightbox,
]);
